import { useEffect } from 'react';
import useAxiosPrivate from '../auth_services/useAxiosPrivate';
import { useRoutes, useNavigate, useLocation } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import AdminRoutes from './AdminRoutes.js';
import useAuth from '../auth_services/useAuth.js';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    // Check login
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();

    // Check login onw time when load page 
    useEffect(() => {
        if (location.pathname != '/apifeepaymentonline') {
            if (useAuth.GetToken() != null) {
                checkLogin();
            } else {
                navigate("/login");
            }
        }
    }, []);

    // Check login every time when path change
    useEffect(() => {
        if (location.pathname != '/apifeepaymentonline') {
            if (useAuth.GetToken() == null) {
                navigate("/login");
            } else {
                navigate(location.pathname);
            }
        }
    }, [location.pathname]);

    const checkLogin = async () => {
        try {
            await axiosPrivate.get('authtoken');
            if (location.pathname == '/' || location.pathname == '/login') {
                navigate('/profile');
            } else {
                navigate(location.pathname);
            }
        } catch (error) {
            navigate("/login");
        }
    }
    //**** Check login */

    return useRoutes([AdminRoutes, LoginRoutes]);
}